import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step12 } from '../../../../shared/models/component-messages/mapaIN/step12';
import { Envoi } from '../models/Envoi';
@Component({
  selector: 'app-envoi',
  templateUrl: './envoi.component.html'
})
export class EnvoiComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Envoi';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() envoi: Envoi;

  public step12 = new Step12();

  constructor() { }

  public ngOnInit() {}
  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

